import React from "react";
import { Box, Typography } from "@mui/material";
import { formatDate } from "../../../../../utils/utils";

function Question({ query }) {
  const { content_object, created_at } = query;

  return (
    <Box>
      <Typography
        variant={"h6"}
        fontWeight={500}
        sx={{ whiteSpace: "pre-wrap" }}>
        {content_object["text"]}
      </Typography>
      <Box mb={0.7} />
      <Typography variant="caption" color={"textSecondary"}>
        {formatDate(created_at)}
      </Typography>
    </Box>
  );
}

export default Question;
